import { Component, OnInit,  ViewChild,  AfterViewInit } from '@angular/core';
import { Router, NavigationEnd, NavigationStart, RouterOutlet } from '@angular/router';
import { NavbarComponent } from '../../shared/navbar/navbar.component';
import PerfectScrollbar from 'perfect-scrollbar';
import { ComunicacionService } from 'src/app/shared/services/comunicacion.service';
import { CommonModule, DatePipe } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { SidebarComponent } from 'src/app/sidebar/sidebar.component';
import { AlertaMonitoreoComponent } from 'src/app/matriz-riesgos-ia/alerta-monitoreo/alerta-monitoreo.component';

declare const $: any;

@Component({
    selector: 'app-layout',
    templateUrl: './admin-layout.component.html',
    imports: [
        FormsModule,
        ReactiveFormsModule,
        CommonModule, 
        RouterOutlet,
        NavbarComponent,
        SidebarComponent,
        AlertaMonitoreoComponent
      ],
       providers: [
        DatePipe
    ] 
})

export class AdminLayoutComponent implements OnInit, AfterViewInit {


    private lastPoppedUrl: string;
    private yScrollStack: number[] = [];
    url: string;
    play: boolean;

    
    @ViewChild('sidebar', {static: false}) sidebar: any;
    @ViewChild(NavbarComponent, {static: false}) navbar: NavbarComponent;
    constructor( private router: Router, 
      private comunicacion:ComunicacionService
      ) {
   
    }
    ngOnInit() {
        const elemMainPanel = <HTMLElement>document.querySelector('.main-panel');
        const elemSidebar = <HTMLElement>document.querySelector('.sidebar .sidebar-wrapper');
     
         this.router.events.subscribe((event:any) => {
            if (event instanceof NavigationStart) {
               if (event.url != this.lastPoppedUrl)
                   this.yScrollStack.push(window.scrollY);
           } else if (event instanceof NavigationEnd) {
               if (event.url == this.lastPoppedUrl) {
                   this.lastPoppedUrl = undefined;
                   window.scrollTo(0, this.yScrollStack.pop());
               }
               else
                   window.scrollTo(0, 0);

               // En escritorio el que hace scroll no es la ventana sino
               // .main-panel (PerfectScrollbar): el scrollTo de arriba
               // no lo toca, así que al entrar a un módulo se heredaba
               // la posición del anterior y la pantalla aparecía hasta
               // abajo, con el contenido fuera de vista y que subir a
               // mano. Cada módulo debe abrirse desde su inicio.
               if (elemMainPanel) {
                   elemMainPanel.scrollTop = 0;
               }
           }
        });
       
        const html = document.getElementsByTagName('html')[0];
        if (window.matchMedia(`(min-width: 960px)`).matches && !this.isMac()) {
            let ps = new PerfectScrollbar(elemMainPanel);
            ps = new PerfectScrollbar(elemSidebar);
            html.classList.add('perfect-scrollbar-on');
        }
        else {
            html.classList.add('perfect-scrollbar-off');
        }

    }
    ngAfterViewInit() {
        this.runOnRouteChange();
    }

    runOnRouteChange(): void {
      if (window.matchMedia(`(min-width: 960px)`).matches && !this.isMac()) {
        const elemSidebar = <HTMLElement>document.querySelector('.sidebar .sidebar-wrapper');
        const elemMainPanel = <HTMLElement>document.querySelector('.main-panel');
        let ps = new PerfectScrollbar(elemMainPanel);
        ps = new PerfectScrollbar(elemSidebar);
        ps.update();
      }
    }
    isMac(): boolean {
        let bool = false;
        if (navigator.platform.toUpperCase().indexOf('MAC') >= 0 || navigator.platform.toUpperCase().indexOf('IPAD') >= 0) {
            bool = true;
        }
        return bool;
    }


}
